import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'

import { App } from 'app/App'
import { msalConfig } from 'auth/config'
import { ApiProvider } from 'providers/ApiProvider'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const fallbackInstance = new PublicClientApplication(msalConfig)

interface RootProps {
  msalInstance?: PublicClientApplication
  getToken?: () => Promise<string>
}

export const Root = ({ msalInstance = fallbackInstance, getToken }: RootProps) => {
  const instance = msalInstance ?? fallbackInstance
  return (
    <StrictMode>
      <MsalProvider instance={instance}>
        <QueryClientProvider client={queryClient}>
          <ApiProvider getToken={getToken}>
            <div id="nma-gallery-root">
              <App />
            </div>
          </ApiProvider>
        </QueryClientProvider>
      </MsalProvider>
    </StrictMode>
  )
}
